module.exports = __webpack_public_path__ + "static/media/rejectwhiteIcon.8c193c55.svg";